/*
 * Pestaña Clientes y Directores, réplica del tab-clientes del HTML original.
 */
import { useMemo } from "react";

import Barlistx from "./Barlistx";
import Panelbox from "./Panelbox";
import { groupSum, htmlTheme, truncate } from "./utils/carthelp";

/**
 * Ordena un mapa de sumas en filas de barra con un color fijo
 * @param {Object} mMap Mapa clave → valor
 * @param {string} sColor Color de la barra
 * @param {number} nTop Máximo de filas
 * @param {number} nTrunc Largo máximo de la etiqueta
 * @returns {Array} Filas [{ label, raw, value, color }]
 */
const toBars = (mMap, sColor, nTop, nTrunc) =>
  Object.entries(mMap)
    .sort((a, b) => b[1] - a[1])
    .slice(0, nTop)
    .map(([sLabel, nValue]) => ({
      label: nTrunc ? truncate(sLabel, nTrunc) : sLabel,
      raw: sLabel,
      value: nValue,
      color: sColor,
    }));

/**
 * Renderiza la pestaña Clientes y Directores
 * @param {Object} props Propiedades del componente
 * @param {Array} props.data Datos de trabajo filtrados
 * @param {Function} props.onFunnel Abre el drill-down (scope, keys, breadcrumb)
 */
const Tabclien = ({ data, onFunnel }) => {
  const mClientes = useMemo(() => toBars(groupSum(data, "NOMBRE"), htmlTheme.navy, 15, 30), [data]);
  const mDirectores = useMemo(() => toBars(groupSum(data, "DIRECTOR DE CUENTA"), htmlTheme.coral, 20), [data]);

  return (
    <>
      <Panelbox title="Top 15 Clientes por Valor Pendiente" hint="Mayor exposición de facturación pendiente">
        <Barlistx
          data={mClientes}
          height={400}
          onItemClick={(m) => onFunnel(data.filter((r) => r.NOMBRE === m.raw), ["TIPO DE OPERACIÓN", "DIRECTOR DE CUENTA"], [`Cliente ${m.raw}`])}
        />
      </Panelbox>
      <Panelbox title="Pendiente por Director de Cuenta" hint="Responsable comercial de cada cliente">
        <Barlistx
          data={mDirectores}
          height={400}
          onItemClick={(m) => onFunnel(data.filter((r) => r["DIRECTOR DE CUENTA"] === m.raw), [], [`Director de Cuenta ${m.raw}`])}
        />
      </Panelbox>
    </>
  );
};

export default Tabclien;
